<li routerLinkActive="active">
  <a class="menu-item items-center flex leading-[60px] p-0 pl-2" href="" [routerLink]="[path()]" (click)="closeMenu()">
    @if (menuIcon() !== undefined) {
      <mat-icon [svgIcon]="menuIcon()!" />
    }
    <span class="ml-[15px] text-[14px]" [innerText]="menuTitle()"></span>
  </a>
</li>
